module.exports = __webpack_public_path__ + "img/phone-icon.cc9750c1.png";